import { withFuncFactory } from '../../libs/IdeLink.Web.Common/src/Factory';
import { OffersModule } from '../modules/Offers/OffersModule';

/** //! { [key: string]: string; } */
export type ApiRoutesMap = Record<string, string>;

const GET_DEFAULT_API_ROUTES_MAP = (): ApiRoutesMap => ({
    [OffersModule.OFFER_LIST_API_ROUTE_KEY]: OffersModule.OFFER_LIST_API_ROUTE,
    [OffersModule.PACKAGED_ORDERS_API_ROUTE_KEY]: OffersModule.PACKAGED_ORDERS_API_ROUTE,
});

const getDefaultApiRoutesMap = (): ApiRoutesMap => GET_DEFAULT_API_ROUTES_MAP();
export const getApiRoutesMapFactory = withFuncFactory(getDefaultApiRoutesMap);

/**
 * Use getRouteMapFactory to get the map, and then the value for the key
 * @param {String} key
 * @returns {String} the route map for the specified key
 */
export const getApiRoute = (key: string) => getApiRoutesMapFactory()[key];
